import { z } from "zod";
import { horaInicioSchema, OBSERVACAO_MAX } from "../../plantoes/schemas/plantaoSchema";
import { EVENT_KIND_ORDER, MAX_EVENT_DAYS } from "../utils/calendarEventKinds";

export const TITULO_MAX = 120;

// Hora e duração só valem em evento de um dia (mesma regra do backend).
export function allowsTime({ tipo, dataInicio, dataFim }) {
  return tipo === "evento" && Boolean(dataInicio) && (!dataFim || dataFim === dataInicio);
}

function daysBetween(inicio, fim) {
  const toUTC = (iso) => {
    const [ano, mes, dia] = iso.split("-").map(Number);
    return Date.UTC(ano, mes - 1, dia);
  };
  return Math.round((toUTC(fim) - toUTC(inicio)) / 86400000);
}

export const calendarEventSchema = z
  .object({
    tipo: z.enum(EVENT_KIND_ORDER, { message: "Escolha o tipo" }),
    titulo: z.string().max(TITULO_MAX, `Até ${TITULO_MAX} caracteres`).default(""),
    dataInicio: z.string().min(1, "Informe a data"),
    dataFim: z.string().min(1, "Informe a data final"),
    horaInicio: horaInicioSchema.default(""),
    horas: z.union([z.string(), z.number()]).default(""),
    observacao: z.string().max(OBSERVACAO_MAX, `Até ${OBSERVACAO_MAX} caracteres`).default(""),
  })
  .superRefine((values, ctx) => {
    if (values.tipo === "evento" && !values.titulo.trim()) {
      ctx.addIssue({ code: "custom", path: ["titulo"], message: "Informe o título do evento" });
    }
    if (values.dataInicio && values.dataFim) {
      const dias = daysBetween(values.dataInicio, values.dataFim);
      if (dias < 0) {
        ctx.addIssue({ code: "custom", path: ["dataFim"], message: "A data final deve ser igual ou posterior à inicial" });
      } else if (dias >= MAX_EVENT_DAYS) {
        ctx.addIssue({ code: "custom", path: ["dataFim"], message: `Um compromisso pode ter até ${MAX_EVENT_DAYS} dias` });
      }
    }
    if (allowsTime(values) && values.horaInicio) {
      const horas = Number(values.horas);
      if (values.horas === "" || !Number.isFinite(horas) || horas <= 0 || horas > 24) {
        ctx.addIssue({ code: "custom", path: ["horas"], message: "Informe a duração (até 24 horas)" });
      }
    }
  });
